export default {
  pageTitle: "Client Contact Types",
  pageDescription:
    "Contact types control which client-facing emails (invoices, reminders, receipts) each contact receives. Each contact can hold one or more types.",
  systemBadge: "System",
  columnName: "Name",
  columnEmailKinds: "Emails received",
  columnContactCount: "Contacts assigned",
  columnActions: "",
  contactCount_one: "{{count}} contact",
  contactCount_other: "{{count}} contacts",
  emailKindInvoice: "Invoice",
  emailKindInvoiceReminder: "Invoice reminder",
  emailKindReceipt: "Receipt",
  upgradeCardHeadline: "Route emails to the right people on Pro",
  upgradeCardBody:
    "Create custom contact types like Technical or Executive and choose which emails each receives.",
  upgradeCardCta: "Upgrade to Pro",
  noEmailKinds: "No emails",
  loading: "Loading contact types…",
  emptyTitle: "No contact types yet",
  emptyMessage:
    "Create a custom type to route emails to specific contacts on each client.",
  toastCreated: "Contact type created",
  toastUpdated: "Contact type updated",
  toastDeleted: "Contact type deleted",
  toastBulkDeleted_one: "{{count}} contact type deleted",
  toastBulkDeleted_other: "{{count}} contact types deleted",
  createButton: "Create type",
  createButtonDisabledTooltip: "Upgrade to Pro to create custom contact types.",
  createModalTitle: "Create contact type",
  editModalTitle: "Edit contact type",
  formNameLabel: "Name",
  formNameRequired: "Name is required",
  formNameMaxLength: "Name must be at most 80 characters",
  formEmailKindsLabel: "Receives emails",
  formEmailKindsDescription:
    "Contacts assigned this type will receive the selected emails.",
  formSubmitCreate: "Create",
  formSubmitSave: "Save",
  deleteModalTitle: "Delete contact type",
  deleteModalMessage_zero:
    "No contacts are assigned this type — it can be deleted safely.",
  deleteModalMessage_one:
    "{{count}} contact will lose this type. Their email routing falls back to other assigned types — or to client.email if they have none.",
  deleteModalMessage_other:
    "{{count}} contacts will lose this type. Their email routing falls back to other assigned types — or to client.email if they have none.",
  deleteConfirmButton: "Delete",
  bulkDeleteToolbar_one: "Delete {{count}} type",
  bulkDeleteToolbar_other: "Delete {{count}} types",
  bulkDeleteModalTitle: "Delete selected contact types",
  bulkDeleteModalMessage:
    "Selected types will be deleted. Their assigned contacts will lose these types and fall back to other assigned types — or to client.email if they have none.",
  bulkDeleteSomeSkipped:
    "Some system types in your selection were skipped: {{codes}}.",
  rowEditAction: "Edit",
  rowDeleteAction: "Delete",
  selectRowAria: "Select {{name}}",
};
